import { axiosInstance } from "#services/axiosInstance.js";
import { useMutation } from "react-query";

const useDelete = (url, queryKey) => {
  const { isLoading, error, mutateAsync } = useMutation(
    queryKey,
    async (data) => {
       const finalUrl = data._customUrl || url;
      const result = await axiosInstance({
        method: "delete",
        url: finalUrl,
        data: data,
        params: data,
        headers: { "Content-Type": "application/json" },
      });
      return result.data;
    },
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return { isLoading, error, mutateAsync };
};

export default useDelete;
